import React from 'react';
import EditCostComponent from '../components/EditCost';
import { AddonsContextConsumer } from '../../../../../context/AddonsContext';

function EditCost(props) {
  return (
    <AddonsContextConsumer>
      {({ actions: {
          getCurrencySymbol, getCurrencyIcon, getAddonsCostByType
        } }) =>
      <EditCostComponent
        {...props}
        getCurrencySymbol={getCurrencySymbol}
        getCurrencyIcon={getCurrencyIcon}
        getAddonsCostByType={getAddonsCostByType} />}


    </AddonsContextConsumer>);

}

export default EditCost;